import { JoinData } from "./JoinDataInt";

const intercomData: JoinData[] = [
  { join: "serial-feedback-Csig.Incoming_Display_Name_fb", name: "Incoming Call Name", x: 598, y: 124, width: 82, height: 26, category: "intercom" },
  { join: "temporarily-hard-coded", name: "Photo or Video URL", x: 386, y: 187, width: 508, height: 288, category: "intercom" },

  { join: "digital-press-Csig.Answer", name: "Answer Call", x: 336, y: 491, width: 84, height: 79, category: "intercom" },
  { join: "digital-press-Csig.Do_Not_Disturb", name: "Do Not Disturb", x: 422, y: 491, width: 106, height: 79, category: "intercom" },
  { join: "digital-press-need-to-do", name: "Close Gate", x: 532, y: 491, width: 106, height: 79, category: "intercom" },
  { join: "digital-press-need-to-do", name: "Open Gate", x: 642, y: 491, width: 106, height: 79, category: "intercom" },
  { join: "digital-press-need-to-do", name: "Hold Gate", x: 752, y: 491, width: 106, height: 79, category: "intercom" },
  { join: "digital-press-Csig.Hangup", name: "End Call", x: 860, y: 491, width: 87, height: 79, category: "intercom" },
  { join: "digital-press-Csig.All_Audio_Volume_Down", name: "Panel Volume Down", x: 513, y: 614, width: 54, height: 59, category: "intercom" },
  { join: "analog-feedback-Csig.All_Audio_Volume_fb", name: "Panel Current Volume", x: 613, y: 614, width: 54, height: 59, category: "intercom" },
  { join: "digital-press-Csig.All_Audio_Volume_Up", name: "Panel Volume Up", x: 713, y: 614, width: 54, height: 59, category: "intercom" },
];

export default intercomData;
